// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__JKg9z","modal":"Modal_modal__oMz10","content":"Modal_content__KNr3z"};